/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Camera = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M14 3L15.286 6H23V21H1V6H4.714L6 3H14ZM13.011 4.5H6.988L5.70301 7.5H2.5V19.5H21.5V7.5H14.297L13.011 4.5ZM10 8C12.7614 8 15 10.2386 15 13C15 15.7614 12.7614 18 10 18C7.23858 18 5 15.7614 5 13C5 10.2386 7.23858 8 10 8ZM10 9.5C8.067 9.5 6.5 11.067 6.5 13C6.5 14.933 8.067 16.5 10 16.5C11.933 16.5 13.5 14.933 13.5 13C13.5 11.067 11.933 9.5 10 9.5ZM19 9C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10C18 9.44772 18.4477 9 19 9Z"
                        fill={color}
                    />
                </svg>
        );
    };
